import * as React from "react";

export type AllIllustrations = Record<string, () => React.ReactNode>;

const IllustrationContext: React.Context<AllIllustrations> =
    React.createContext({});
IllustrationContext.displayName = "IllustrationContext";

export default IllustrationContext;
